
<div class="align-center">
  <span mat-dialog-content style="margin-bottom: 20px;">
    Are you sure you want to cancel?
  </span>
  <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.xs="column" fxLayout.sm="column">
    <button fxFlex="45" mat-raised-button color="primary" (click)="close()" type="button">Yes</button>
    <button fxFlex="45" mat-button type="button" color="primary"
    (click)="dialogRef.close()" type="button">No</button>
  </div>
</div>
